import { gql } from '@apollo/client';

export interface Email {
  organizationId: string;
  subject: string;
  body: string;
  divisions: Division[];
  isDraft: boolean;
  isOrg: boolean;
  senderEmailAddress: string;
  senderName: string;
}

interface Division {
  id: number;
  name: string;
  programName: string;
  programId: number;
  seasonName: string;
  seasonId: number;
  isUnassigned: boolean;
}

export const MUTATION = gql`
  mutation CreateEmail(
    $organizationId: Int!
    $subject: String!
    $body: String!
    $divisions: [DivisionInput]
    $isDraft: Boolean
    $isOrg: Boolean
    $senderEmailAddress: String
    $senderName: String
  ) {
    createEmail(
      input: {
        organizationId: $organizationId
        subject: $subject
        body: $body
        divisions: $divisions
        isDraft: $isDraft
        isOrg: $isOrg
        senderEmailAddress: $senderEmailAddress
        senderName: $senderName
      }
    ) {
      id
    }
  }
`;
